<template>
  <v-card class="mx-auto" align="center" max-width="800" outlined>
    <v-alert dismissible outlined type="error" dense>
      Attenzione: Bozza
      <strong>Non</strong> Operativa
    </v-alert>
    <v-alert v-if="false" class="white--text elevation-3 green title">Emergenza Coronavirus</v-alert>
    <v-img
      alt="Numero Verde 1500"
      contain
      src="@/assets/nv1500covid.png"
      transition="scale-transition"
      width="350"
    />
    <v-card-actions>
      <v-toolbar dense>
        <v-btn to="/Login" text>Login</v-btn>
        <v-spacer></v-spacer>
        <v-btn to="/Start" color="accent">Inizia</v-btn>
      </v-toolbar>
    </v-card-actions>
    <v-carousel cycle height="340" show-arrows-on-hover interval="3000">
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <v-sheet :color="colors[i]" height="100%">
          <v-row class="fill-height" align="center" justify="center">
            <v-row>
              <v-col cols="12">
                <div class="display-1">{{ slide.title }}</div>
              </v-col>
              <v-col cols="12">
                <div class="headline">{{ slide.subtitle }}</div>
              </v-col>
            </v-row>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </v-card>
</template>
<script>
// import GeoDialog from "@/components/GeoDialog";
export default {
  components: {
    // GeoDialog
  },
  data() {
    return {
      colors: [
        "indigo darken-2",
        "success darken-2",
        "pink darken-2",
        "amber darken-2",
        "deep-purple accent-4"
      ],
      slides: [
        { title: "Coronavirus", subtitle: "Segnala Sintomi" },
        { title: "Dove Abitate", subtitle: "trova sulla mappa" },
        {
          title: "Situazione Attuale",
          subtitle: "sintomi importanti"
        },
        {
          title: "Caratteristiche Fisiche",
          subtitle: "fattori di rischio"
        },
        { title: "Aggiornaci", subtitle: "Aggiungi dati quotidianamente" }
      ]
    };
  }
};
</script>
